import type { Brand } from '../@types/Brand.types';

const map = new Map<
  Brand,
  Extract<
    Brand,
    | 'axofinans.no'
    | 'axolaina.fi'
    | 'zmarta.fi'
    | 'zmarta.se'
    | 'lendme.dk'
  >
>([
  // Norway
  // Axo Finans AS
  ['axofinans.no', 'axofinans.no'],
  ['uloan.no', 'axofinans.no'],
  ['uscore.no', 'axofinans.no'],
  ['centum.no', 'axofinans.no'],
  ['lendme.no', 'axofinans.no'],
  ['zmarta.no', 'axofinans.no'],

  // Finland
  // Axo Finance Oy
  ['axolaina.fi', 'axolaina.fi'],
  ['uscore.fi', 'axolaina.fi'],

  // Zmarta Finland (Freedom Rahoitus Oy)
  ['zmarta.fi', 'zmarta.fi'],
  ['freedomrahoitus.fi', 'zmarta.fi'],

  // Sweden
  // Zmarta AB, also the loan broker for uscore.se (since March 2026)
  // and axofinans.se (since June 2026)
  ['axofinans.se', 'zmarta.se'],
  ['uscore.se', 'zmarta.se'],
  ['zmarta.se', 'zmarta.se'],
  ['freedomfinance.se', 'zmarta.se'],

  // Denmark
  // LendMe (MNW ApS)
  ['lendme.dk', 'lendme.dk'],
]);

export const getBrandForGeneralConsent = (brand: Brand) => {
  if (!map.has(brand))
    throw new Error(`No general consent brand found for ${brand}`);

  return map.get(brand) || brand;
};
